export const MAX_PURCHASE_QUANTITY = 100;
export const MUST_BE_IN_APP_MESSAGE_WARNING =
  "inAppMessage must be an InAppMessage object";
export const MUST_BE_CARD_WARNING_SUFFIX = "must be a Card object";
export const FEED_ANIMATION_DURATION = 500;
